import styled from "styled-components"

import logoBlue from "assets/svg/logo-blue.svg"

import { textDark, textGrey } from "./shared"

const HeaderBar = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1180px;
  margin: 0 auto;
  padding: 24px 24px 8px;
`

const Logo = styled.img`
  height: 32px;
  /* the asset is cyan; the landing design uses the black logo */
  filter: brightness(0);
`

const Nav = styled.nav`
  display: flex;
  gap: 24px;

  a {
    color: ${textDark};
    font-size: 0.8125rem;
    font-weight: 500;
    text-decoration: none;

    &:hover {
      color: ${textGrey};
    }
  }
`

export const Header = () => (
  <HeaderBar>
    <Logo src={logoBlue} alt="Nuve" />
    <Nav>
      <a href="#how-it-works">How it works</a>
      <a href="#faq">FAQ</a>
    </Nav>
  </HeaderBar>
)
